const app = {
    modal: {
        close: 'Schließen',
        ok: 'OK',
        cancel: 'Abbrechen',
        save: 'Speichern',
        saving: 'Speichern...',
    },
    products: {
        title: 'Produkte',
        new: 'Neuheiten',
        all: 'Alle Produkte',
        sizes: '',
        excludeVAT: 'exkl. MwST',
        startDesign: 'Design starten',
        searchResults: 'Suchergebnisse für &#8222;<strong>{query}</strong>&#8220;',
        noResults: 'Keine Ergebnisse gefunden',
        showInShop: 'Produkt im Store anzeigen',
        connectProduct: 'TiB Product Verbinden',
        connectProductId: 'Shopify Produkt ID',
        regionFilter: {
            allRegions: 'Alle Regionen',
            europe: 'Europa & Rest der Welt',
            america: 'Nord- & Südamerika',
            mixedCurrencyInfo:
                'Produkte, die ausschließlich an unserem Standort in den USA oder ausschließlich an unserem Standort in Europa produziert werden, besitzen nur einen Preis in der jeweiligen Standortwährung ($ bzw. €). Produkte, die an beiden Standorten produziert werden, zeigen entsprechend zwei Preise. Die Rechnungsstellung erfolgt stets in der Währung des jeweiligen Produktionsstandorts.',
        },
    },
    tibProductConnect: {
        error: {
            title: 'Produkt konnte nicht verbunden werden',
            variantNotFound: 'Die folgenden Varianten konnten nicht gematched werden:\n',
        },
        success: {
            title: 'Produkt wurde erfolgreich verbunden',
        },
    },
    mainShop: {
        title: 'Mein Shop',
    },
    orders: {
        title: 'Bestellungen',
        personalized: 'Personalisierte Bestellungen',
        notEu: 'Nicht EU Bestellungen',
        personalizedShort: 'Personalisiert',
        notEUShort: 'Nicht EU',
        addressMissing: 'Fehlende Adresse',
        all: 'Alle',
        splittedOrders: 'Teil dieser Bestellung:',
    },
    myStores: {
        title: 'Meine Shops',
        storeRegion: 'Shop-Region',
        billingCurrency: 'Abrechnungswährung',
        activeButton: 'Aktiv',
        inactiveButton: 'Inaktiv',
        viewStoreButton: 'Shop ansehen',
        editStoreDetailsButton: 'Shopdetails bearbeiten',
        addProductButton: 'Produkt hinzufügen',
        title2: 'Neuen Shop verbinden',
        subtitle2:
            'Es ist eine allgemein bekannte Tatsache, dass ein Leser vom lesbaren Inhalt einer Seite abgelenkt wird, wenn er ihr Layout betrachtet.',
        connectButton: 'Verbinden',
        brandDescriptions: {
            shopify:
                'Shopify ist eine attraktive Wahl für kleine Unternehmen und bietet eine umfassende Plattform mit benutzerfreundlichen Tools und erschwinglichen Preisen.',
            woocommerce:
                'WooCommerce ist eine etablierte und leistungsstarke E-Commerce-Plattform auf Basis von WordPress mit umfangreichen Anpassungsmöglichkeiten.',
            amazon: 'Amazon ist eine attraktive Wahl für kleine Unternehmen und bietet eine umfassende Plattform mit benutzerfreundlichen Tools und erschwinglichen Preisen.',
            etsy: "Etsy bietet eine einfache und schnelle Möglichkeit, mit dem Verkauf zu beginnen und mit Millionen von aktiven Käufern auf der ganzen Welt in Kontakt zu treten, was es zu einer idealen Wahl für neue Verkäufer macht.<br><br>The term 'Etsy' is a trademark of Etsy, Inc. This application uses the Etsy API but is not endorsed or certified by Etsy, Inc.",
            tiktok: 'TikTok Shop ist ideal für Händler, die Social Commerce nutzen möchten, indem es die Unterhaltung von TikTok mit einem nahtlosen Einkaufserlebnis kombiniert, um ein hoch engagiertes Publikum zu erreichen.<br><br>Besonderheiten: Zugang zu einem jungen, dynamischen Publikum mit über 1 Milliarde aktiven Nutzern &middot; Nahtlose Integration mit TikTok-Inhalten &middot; Integrierte Tools für Live-Shopping und In-App-Käufe.',
        },
        woocommerce: {
            modalTitle: 'WooCommerce Shop verbinden',
            modalDescription:
                'Gib die URL deines WooCommerce-Shops ein. Du wirst anschließend zu deinem Shop weitergeleitet, um MarketPrint den Zugriff zu genehmigen.',
            modalConnect: 'Weiter',
            shopUrlLabel: 'Shop-URL',
            shopUrlPlaceholder: 'https://meinshop.de',
            shopUrlHint: 'Die vollständige URL deines WooCommerce-Shops inkl. https://',
            modalInfo:
                'Du wirst zu deiner WooCommerce-Installation weitergeleitet und musst dort den Zugriff für MarketPrint genehmigen. Stelle sicher, dass du in deinem WooCommerce-Shop eingeloggt bist.',
            redirecting: 'Du wirst weitergeleitet...',
            missingShopUrl: 'Keine Shop-URL angegeben.',
        },
        learnMoreLink: 'Mehr erfahren',
        noShops: 'Derzeit sind keine Shops verbunden.',
        scopeButton: 'Update Shop',
        updateShopText:
            'Mindestens einer deiner Shops muss aktualisiert werden. <br>Klicke dazu auf den "Update Shop" Button und genehmige die Anfrage in Shopify.',
    },
    myDesign: {
        title: 'Meine Designs',
    },
    myDesignLibrary: {
        title: 'Design-Bibliothek',
        deleteConfirm: 'Willst du das Design wirklich löschen?',
    },
    myNeckPrintDesignLibrary: {
        title: 'Nackenbranding',
        deleteConfirm: 'Willst du das Design wirklich löschen?',
        lightGarment: 'Alle hellen Kleidungsstücke',
        darkGarment: 'Alle dunklen Kleidungsstücke',
        allGarments: 'Helle und Dunkle Kleidungsstücke',
        selectBothImages: 'Bitte wähle ein Bild für sowohl helle als auch dunkle Kleidungsstücke aus.',
    },
    returns: {
        title: 'Retourenmanagement',
        noReturns: 'Derzeit sind keine Retouren vorhanden.',
        startDate: 'Anfangsdatum',
        endDate: 'Enddatum',
        store: 'Shop',
        status: {
            title: 'Status',
            PENDING: 'Ausstehend',
            PARTIALLY_COMPLETED: 'Teilweise abgeschlossen',
            COMPLETED: 'Abgeschlossen',
        },
        itemStatus: {
            allStatuses: 'Alle Status',
            itemsPendingRefund: 'Rückerstattung ausstehend',
            PENDING: 'Ausstehend',
            ACCEPTED: 'Akzeptiert',
            REJECTED: 'Abgelehnt',
            STORED: 'Gelagert',
            SOLD: 'Verkauft',
            complaintUnderReview: 'Reklamation in Prüfung',
            complaintRejected: 'Reklamation abgelehnt',
            complaintAccepted: 'Reklamation akzeptiert',
        },
        combinedStatus: {
            RETURN_ANNOUNCED: 'Retoure angekündigt',
            RETURN_STORED: 'Retoure eingelagert',
            RETURN_REJECTED: 'Retoure abgelehnt',
            RETURN_SOLD: 'Retoure verkauft',
            COMPLAINT_UNDER_REVIEW: 'Reklamation in Prüfung',
            COMPLAINT_REJECTED: 'Reklamation abgelehnt',
            COMPLAINT_ACCEPTED: 'Reklamation akzeptiert',
        },
        search: 'Suche',
        reset: 'Filter zurücksetzen',
        searchPlaceholder: 'Suche nach Bestellung oder Name',
        //tableHeaders:
        orderId: 'Bestell-ID',
        orderName: 'Bestellung',
        statusTitle: 'Status',
        date: 'Datum',
        customer: 'Kunde',
        isDone: 'An End-Kunden erstattet?',
        product: 'Produkt',
        noProductTitle: 'Kein Produkttitel',
        subscription: 'Abonnement',
        isReturnManagementActive: 'Retourmanagement',
        frameUrl: 'IFrame URL',
        activate: 'Abonnieren',
        deactivate: 'Deaktivieren',
        copiedToClipboard: 'In die Zwischenablage kopiert',
    },
    resources: {
        title: 'Ressourcen',
        blog: 'Print-On-Demand Blog',
        whatsappChannel: 'WhatsApp Channel',
        productAndDeliverInformation: 'Produkt- und Lieferinformationen',
        productImages: 'Produkt-Bilder',
        helpAndFaqs: 'Hilfe & FAQs',
        bulkOrders: 'Großbestellungen',
        warehousing: 'Warehousing',
    },
    deliveryInformation: 'Lieferinformationen',
    account: {
        affiliateProgram: 'Affiliate Programm',
        title: 'Account',
        invoices: 'Rechnungen',
        walletTransactions: 'Wallet Transaktionen',
        settings: 'Einstellungen',
        myStores: 'Meine Shops',
        logout: 'Abmelden',
        logoutMessage: 'Du wurdest abgemeldet, da es Probleme mit deinem Konto gibt.',
    },
    sampleOrder: {
        title: 'Bestellung anlegen',
        step1Title: 'Shop auswählen',
        step2Title: 'Produkte auswählen',
        step3Title: 'Lieferadresse',
        step4Title: 'Überprüfen & Absenden',
        selectStoreSubtitle: 'Wähle den Shop, über den das Muster bestellt wird',
        submit: 'Bestellung aufgeben',
        total: 'Gesamt',
        country: 'Land *',
        firstName: 'Vorname *',
        lastName: 'Nachname *',
        address1: 'Adresszeile 1 *',
        address2: 'Adresszeile 2',
        city: 'Stadt *',
        zip: 'PLZ *',
        province: 'Bundesstaat',
        phone: 'Telefon',
        email: 'E-Mail',
        reviewStore: 'Ausgewählter Shop',
        reviewProducts: 'Ausgewähltes Produkt | Ausgewählte Produkte',
        invalidCity: 'Der Ortsname sieht zu kurz aus.',
        invalidZip: 'Diese PLZ passt nicht zum ausgewählten Land.',
        invalidStreet: 'Bitte Straße und Hausnummer angeben.',
        provinceRequired: 'Bitte einen Bundesstaat auswählen.',
        invalidEmail: 'Bitte eine gültige E-Mail-Adresse angeben.',
        countryPlaceholder: 'Land auswählen',
        countryRestricted: 'Für die gewählte Produkt-Region ist nur Lieferung in diese Länder möglich.',
        countrySearchPlaceholder: 'Land suchen...',
        countryNoMatch: 'Kein Land gefunden',
        region: 'Region',
        regionEu: 'Europa & Rest der Welt',
        regionUsa: 'USA',
        selectedItems: 'Ausgewählte Produkte',
        totalQuantity: 'Gesamtmenge',
        maxItems: 'Die Gesamtmenge darf 200 Artikel nicht überschreiten.',
        loadingProducts: 'Produkte werden geladen...',
        noProducts: 'Keine Produkte gefunden.',
        steps: {
            store: 'Shop',
            products: 'Produkte',
            shipping: 'Versand',
            review: 'Überprüfen',
        },
        noPaymentMethod:
            'Für diesen Shop ist noch keine Zahlungsmethode hinterlegt. Die Bestellung wird erst verarbeitet, sobald eine Zahlungsmethode hinterlegt ist.',
        addPaymentMethod: 'Zahlungsmethode hinterlegen',
        submitSuccess: 'Deine Musterbestellung {orderId} wurde erstellt!',
        startAnother: 'Weitere Bestellung anlegen',
        errorZipInvalid: 'Die PLZ ist für das gewählte Land nicht gültig. Bitte prüfe die Lieferadresse.',
        errorZipStateMismatch: 'PLZ und Bundesstaat passen nicht zusammen. Bitte prüfe die Lieferadresse.',
        editAddress: 'Adresse ändern',
        submitError: 'Etwas ist schiefgelaufen. Bitte versuche es erneut.',
        priceHeader: 'Rechnungsbetrag',
        priceLoading: 'Preis wird berechnet...',
        priceError: 'Der Preis konnte nicht berechnet werden. Bitte prüfe die Lieferadresse.',
        priceRetry: 'Neu berechnen',
        shipping: 'Versand',
        netTotal: 'Zwischensumme (netto)',
        tax: 'MwSt. ({rate} %)',
        vipDiscount: 'VIP-Kunden Rabatt',
        free: 'kostenfrei',
        vatInfo6: 'Steuerfreie Ausfuhr nach § 6 UStG.',
        vatInfo6a: 'Steuerfreie innergemeinschaftliche Lieferung nach § 6a UStG.',
    },
    pagination: {
        prev: 'Zurück',
        next: 'Vor',
        further: 'Weiter',
        create: 'Erstellen',
        save: 'Speichern',
    },
    search: {
        placeholder: 'Suche',
    },
    sort: {
        value: 'Sortierung',
    },
    filter: {
        label: 'Filter',
        searchPlaceholder: 'Kategorien suchen...',
        clearAll: 'Alle löschen',
        noResults: 'Keine Kategorien gefunden',
    },
    creditCard: {
        error: {
            title: 'Kreditkarte konnte nicht hinterlegt werden',
            tokenContent: 'Ungültige Kreditkarten-Informationen',
            backendContent: 'Fehler beim Hinterlegen der Daten',
        },
        success: {
            title: 'Erfolgreich gespeichert',
            content: 'Deine Kreditkarte wurde erfolgreich hinterlegt',
        },
    },
    welcomeBlock: {
        title: `Willkommen{username}`,
        suggest: 'Durchstöbere unser Produktportfolio und kreiere in weniger als 2 Minuten dein Print on Demand Produkt.',
        subtitle:
            "--- Tagesaktuelle Known Issues findet ihr <a target='_blank' rel='noopener noreferrer' href='https://help.marketprint.de/known-issues/'>hier</a>. ---<br><br>Das lang ersehnte <b>MarketPrint 2.0</b> Update ist endlich online! Wir haben das komplette Frontend geändert, um euch ein noch besseres Nutzererlebnis zu bieten.<br><br>Sollte es innerhalb der ersten zwei Wochen noch zu kleinen Problemen kommen, ruf uns gerne unter der Telefonnummer<b>+49 8261 7939101</b> an.<br>Oder hinterlass deine Meinung und Vorschläge für künftige Neuerungen unter: <b>feedback@marketconsultive.de</b><br><br>Wir wünschen dir viel Spaß mit dem neuen Design und sind gespannt von dir zu hören! Wir sind noch lange nicht am Ende und danken dir für deine Treue.<br><br>- Das komplette Team der <i>MarketConsultive GmbH</i><br><br>PS: Ein paar spannende Features, wie deine eigene Design-Bibliothek, werden in den nächsten Wochen für dich bereitgestellt! Schau auch mal auf <a target='_blank' rel='noopener noreferrer' href='https://www.marketprint.de'>www.marketprint.de</a> vorbei! Außerdem planen wir für das Wintergeschäft ein komplettes Produktportfolio von mindestens 20 (!) neuen Bestseller-Produkten, die innerhalb der nächsten Wochen und Monate online gehen.",
        cta: 'Jetzt Produkt kreieren',
    },
    productsIntro: {
        title: 'Unser Produktsortiment',
    },
    currentOrders: {
        title: `Aktuelle Bestellungen:`,
        more: 'Mehr anzeigen...',
    },
    currentOrdersModal: {
        shopifyId: 'Shopify ID',
        trackingNumber: 'Sendungsnummer(n)',
        moreInfo: 'Mehr Infos',
        paymentMethod: 'Zahlungsart',
        transactionNumber: 'Transaktionsnummer',
        ordered: 'Bestellt',
        inProcess: 'In Produktion',
        shipped: 'Versandt',
        cancelled: 'Storniert',
        refunded: 'Rückerstattet',
        yes: 'Ja',
        no: 'Nein',
        btnUploadDesigns: 'Upload Designs',
        btnReleaseForProduction: 'Zur Produktion freigeben',
        btnViewOrder: 'Bestellung anzeigen',
        btnUpdateCustomerData: 'Adresse aktualisieren',
        updateCustomerData: 'Kundendaten ändern',
        btnDownloadInvoice: 'Download Rechnung',
        textReleaseForProduction: 'Willst du diese Bestellung wirklich zur Produktion freigeben?',
        orderReady: 'Bestellung wurde zur Produktion freigegeben!',
        orderReadyErrorTitle: 'Bestellung konnte nicht zur Produktion freigegeben werden!',
        orderReadyError: 'Überprüfe die Designs auf Vollständigkeit!',
        btnUploadInvoices: 'Upload Rechnung',
        invoice: 'Rechnung',
        selectVariant: 'Wähle Variante',
        selectImage: 'Personalisiertes Design',
        confirmationUpload: 'Upload erfolgreich!',
        notPayed: 'Zahlung an MarketPrint fehlgeschlagen. Bitte in den Einstellungen erneut versuchen oder an den Support wenden.',
        noPreview: 'Momentan kein Vorschau für Tassen! \n Trotzdem kann das Design hochgeladen werden.',
        for: 'für',
        btnRetryPayment: 'Zahlung neu versuchen',
        uploaded: 'Designs hochgeladen',
        downloadInvoice: 'Rechnungs-Download',
        noInvoice: 'Rechnung nicht verfügbar',
        noMockups: 'Mockups nicht verfügbar für dieses Produkt',
        btnCancel: 'Bestellung stornieren',
        cancelReason: 'Grund für die Stornierung',
        textCancel: 'Soll diese Bestellung wirklich storniert werden?',
        orderCancelErrorTitle: 'Bestellung konnte nicht storniert werden',
        orderCancelled: 'Bestellung wurde storniert',
        orderCancelError: 'Die Bestellung ist möglicherweise bereits in Produktion oder versendet.',
        invoiceUploadErrorTitle: 'Rechnungs-Upload fehlgeschlagen',
        invoiceUploadError: 'Der Rechnungs-Upload ist fehlgeschlagen. Bitte versuchen Sie es später erneut oder aktualisieren Sie die Seite.',
        invoiceUploadSuccess: 'Rechnung erfolgreich hochgeladen',
        btnAddAddress: 'Adresse hinzufügen',
        addAddress: 'Lieferadresse hinzufügen',
        firstName: 'Vorname',
        lastName: 'Nachname',
        address1: 'Adresse',
        city: 'Stadt',
        zip: 'PLZ',
        countryCode: 'Ländercode',
        addressAddedSuccess: 'Adresse erfolgreich hinzugefügt',
        addressAddedError: 'Fehler beim Hinzufügen der Adresse',
    },
    checklist: {
        title: `Deine Checkliste`,
        subtitle: `Nur noch wenige Schritte um deinen Shop einzurichten!`,
        installApp: `MarketPrint-App installieren`,
        createProduct: `Produkt erstellen`,
        paymentMethod: `Zahlungsmethode auswählen`,
    },
    todoOrders: {
        title: `Deine TODO’s`,
        subtitle: `Vervollständige deine Bestellungen`,
        order: `Lade die Rechnung für die Bestellung <strong>#{id}</strong> hoch`,
    },
    sortOptions: {
        relevance: 'Relevanz',
        newArrivals: 'Neuankömmling',
        bestSelling: 'Meistverkauften',
        priceLowHigh: 'Preis Niedrig Hoch',
        priceHighLow: 'Preis Hoch Niedrig',
        ratings: 'Bewertung',
    },
    home: {
        bestseller: 'Aktuelle MarketPrint Bestseller',
        newProducts: 'Neue Produkte',
        shopConnectSuccess: {
            title: 'Shop Verbunden',
            content: 'Du hast deinen Shop erfolgreich mit MarketPrint verbunden.',
        },
        shopConnectError: {
            title: 'Shop Verbindungsfehler',
            content: 'Beim Verbinden deines Shops mit MarketPrint ist ein Fehler aufgetreten. Bitte versuche es später erneut.',
            alreadyConnected: 'Beim Verbinden deines Shops ist ein Fehler aufgetreten: Der Shop ist bereits mit einem anderen Account verbunden.',
        },
    },
    ordersIntro: {
        orders: 'Bestellübersicht',
        personalized: 'Personalisierte Bestellungen',
        notEu: 'Nicht EU Bestellungen',
    },
    design: {
        editMode: 'Bearbeitungsmodus',
        editingProduct: 'Bearbeiten:',
        personalizedEditLocked: 'Personalisierte Produkte können nicht verändert werden. Nur Titel, Beschreibung und Preise können angepasst werden.',
        variantsAddOnly: 'Bestehende Farben und Größen können nicht entfernt, nur neue hinzugefügt werden.',
        selectShop: 'Für welche Shop möchtest du ein Produkt erstellen?',
        selectShopTitle: 'Shop auswählen',
        front: 'Vorne',
        back: 'Hinten',
        left: 'Links',
        right: 'Rechts',
        colors: 'Farben',
        size: 'Größe',
        sizes: 'Größen',
        design: 'Design',
        neckPrint: 'Nackenbranding',
        waistband: 'Bund',
        cuffLeft: 'Ärmelende Links',
        cuffRight: 'Ärmelende Rechts',
        collar: 'Kragen',
        forearmRight: 'Unterarm Rechts',
        forearmLeft: 'Unterarm Links',
        useDifferentGarment: 'Verwende unterschiedliche Bilder für helle und dunkle Kleidungsstücke',
        showGreenArea: 'Grünen Bereich anzeigen',
        titleLibraryNeckPrints: 'Nacken-Print-Bibliothek',
        countries: 'Länder',
        germany: 'Deutschland',
        austria: 'Österreich',
        switzerland: 'Schweiz',
        landArea: 'Land / Zone',
        alternativeDesign: 'Alternatives Design',
        alternativeDesignColors: 'Alternatives Design für folgende Farben',
        productDescription: 'Produktbeschreibung',
        howToDesign: 'Tutorial: Dieses Produkt korrekt anlegen',
        downloadProductData: 'Produktdatenblatt und Mockups herunterladen',
        designNote: 'Hinweise zum Anlegen des Designs',
        sizeChart: 'Größentabelle',
        insertGraphic: 'Grafik einfügen',
        moveLayerUp: 'Ebene nach oben',
        moveLayerDown: 'Ebene nach unten',
        important: `<span>Wichtig:</span> Platziere dein Design innerhalb der grünen Außenmarkierung. Beim überschreiten der Linien wird dein Design nicht vollständig auf das Produkt gedruckt.`,
        productTitle: 'Produkttitel',
        productTitlePlaceholder: 'Titel hinzufügen',
        productDescriptionPlaceholder: 'Beschreibung hinzufügen',
        doubleSidedPrint: 'Mehrseitig bedruckt - bereits eingerechnet',
        additionalNeckPrice: 'Nackendruck - bereits eingerechnet',
        purchasePriceVat: 'Einkaufspreis (exkl. MwSt)',
        purchasePrice19Vat: 'Einkaufspreis (inkl. 19% MwSt)',
        sellingPrice19VAt: 'Verkaufspreis (inkl. 19% MwSt)',
        sellingPrice: 'Verkaufspreis',
        profitMargin: 'Deine Gewinnmarge (Brutto)',
        profitMarginWithVat: 'Deine Gewinnmarge',
        price: 'Preis',
        shippingCostsOverview: 'Versandkostenübersicht',
        shippingPrice: 'Versandpreis',
        shippingPricesAreNet: 'Alle Preise sind netto.',
        shippingProduct: 'Produkt',
        usaShippingStandard: 'T-Shirts und andere Produkte',
        usaShippingHeavy: 'Hoodies, Sweatshirts, Zipper, Sweatpants',
        additionalPricePerProduct: 'Pro zusätzlichem Produkt in der Bestellung wird 0.84 € zusätzlich berechnet',
        additionalItems: 'Zusätzliche Artikel',
        addSizeChart: 'Größentabelle zum Shop hinzufügen',
        publishProduct: 'Produkt in Shopify veröffentlichen',
        collections: 'Kollektionen',
        collectionsLoading: 'Kollektionen werden geladen...',
        noCollections: 'Keine Kollektionen verfügbar',
        collectionsSearch: 'Kollektionen suchen...',
        collectionsNoResults: 'Keine passenden Kollektionen',
        collectionsSelected: '{count} ausgewählt',
        catalogs: 'Kataloge',
        catalogsLoading: 'Kataloge werden geladen...',
        noCatalogs: 'Keine Kataloge verfügbar',
        catalogsSearch: 'Kataloge suchen...',
        catalogsNoResults: 'Keine passenden Kataloge',
        catalogsSelected: '{count} ausgewählt',
        shippingProfiles: 'Versandprofil',
        shippingProfilesLoading: 'Versandprofile werden geladen...',
        noShippingProfiles: 'Keine Versandprofile verfügbar',
        shippingProfilesSearch: 'Versandprofile suchen...',
        shippingProfilesNoResults: 'Keine passenden Versandprofile',
        shippingProfileDefault: 'MarketPrint Standardversand',
        shopSelectionTitle: 'Shop auswählen',
        shopSelectionSubtitle: 'Wählen Sie den Shop aus, dem Sie Ihr Produkt hinzufügen möchten',
        chooseMockup: 'Wähle dein Mockup aus',
        titleLibrary: 'Deine Design-Bibliothek',
        addDesignLibrary: `Neues Design hochladen`,
        personalProduct: 'Dies ist ein personalisierbares Produkt',
        tibProductFront: 'Vorne Optimieren',
        tibProductBack: 'Hinten Optimieren',
        tibProductSleeveLeft: 'Ärmel Links Optimieren',
        tibProductSleeveRight: 'Ärmel Rechts Optimieren',
        tibProductLeft: 'Links Optimieren',
        tibProductRight: 'Rechts Optimieren',
        tibProductFrontLeft: 'Vorne Links Optimieren',
        tibProductFrontRight: 'Vorne Rechts Optimieren',
        tibProductBackLeft: 'Hinten Links Optimieren',
        tibProductBackRight: 'Hinten Rechts Optimieren',
        tibProductSideLeft: 'Seite Links Optimieren',
        tibProductSideRight: 'Seite Rechts Optimieren',
        tibProductTop: 'Oben Optimieren',
        tibProductChestLeft: 'Linke Brust Optimieren',
        tibProductChestRight: 'Rechte Brust Optimieren',
        tibProductForearmLeft: 'Unterarm Links Optimieren',
        tibProductForearmRight: 'Unterarm Rechts Optimieren',
        tibProductCuffLeft: 'Ärmelende Links Optimieren',
        tibProductCuffRight: 'Ärmelende Rechts Optimieren',
        tibProductWaistband: 'Bund Optimieren',
        tibProductCollar: 'Kragen Optimieren',
        tibProductAll: 'Alle Seiten Optimieren',
        quality: {
            good: 'Gut',
            normal: 'Mittel',
            bad: 'Schlecht',
        },
        productCreated: 'Produkt erstellt',
        productCreateError: 'Produkt konnte nicht erstellt werden',
        productUpdated: 'Produkt erfolgreich aktualisiert',
        productUpdateError: 'Produkt konnte nicht aktualisiert werden',
        maxOne: 'Maximal eine Grafik',
        infoCanvas: `<span>Platzierung:</span> Vorderseite des Canvas innerhalb des dunkelgrauen Rahmens,
              seitliche
              Überlappung bis zur grünen Linie.`,
        infoPoster: `<span>Platzierung:</span> Platzierung des
              Designs bis zur äußeren grünen Linie. Hellgrauer
              Bereich wird bei Produktion abgeschnitten.`,
        infoGlas: `<span>Keine Platzierung:</span> Für Gravurarbeiten stellen wir <b>keine</b> Platzierung zur
                            Verfügung, bitte ändere deine Vektorgrafik entsprechend und lade das Bild anschließend
                            erneut hoch, um die Platzierung anzupassen.<br><br>
                      <span>Festes Seitenverhältnis:</span> Achte darauf, dass dein SVG die <b>Breite
                          {printMediumWidth} </b> und <b>Höhe {printMediumHeight}</b> hat.<br>
                            Alternativ setze Breite und Höhe so, dass sie das gleiche Seitenverhältnis haben wie <b> {printMediumAspectRatio} </b>.<br><br>
                         <span>Nur eine Design-Datei:</span> Es kann <b>nur eine</b> Vekorgrafik für das Design
                            verwendet werden.`,
        disabledStep2: `Um zum nächsten Schritt zu gelangen, müssen Sie wählen: Farbe, Größe und Bild hochladen`,
        disabledStep3: `Um zum nächsten Schritt zu gelangen, müssen Sie den Produktnamen, die Beschreibung und den Preis angeben`,
        uploadErrorMessageBeer:
            'SVG Seitenverhältnis stimmt nicht mit Seitenverhältnis des Printmediums (Breite/Höhe = 1.67) überein. Bitte versuche es nochmal mit einer passenden Datei!',
        uploadErrorMessageWine:
            'SVG Seitenverhältnis stimmt nicht mit Seitenverhältnis des Printmediums (Breite/Höhe = 1) überein Bitte versuche es nochmal mit einer passenden Datei!',
        uploadErrorPngOnly: 'Bitte verwende ein .png-Bild für dieses Produkt',
        uploadErrorTitle: 'Fehler bei Upload',
        sleeveRight: 'Ärmel Rechts',
        sleeveLeft: 'Ärmel Links',
        frontLeft: 'Vorne Links',
        frontRight: 'Vorne Rechts',
        backLeft: 'Hinten Links',
        backRight: 'Hinten Rechts',
        sideLeft: 'Seite Links',
        sideRight: 'Seite Rechts',
        top: 'Oben',
        chestLeft: 'Linke Brust',
        chestRight: 'Rechte Brust',
        combinedDesignTitle: 'Gleiches Design auf allen Seiten',
        combinedDesignDescription: 'Deaktiviere diese Option, wenn du unterschiedliche Designs für den linken und rechten Schuh verwenden möchtest.',
        designDownload: 'Design Download',
        addToShop: 'Hinzufügen zu Shop',
        sizeChartTooltip: 'Die Größentabelle zeigt deinen Kunden die verschiedenen Maße des Produkts.',
        supportedPrinterTypes: 'Drucktechnik:',
        printerType: {
            dtf: 'DTF',
            dtg: 'DTG',
            sublimation: 'Sublimation',
            laser: 'Laser',
            aop: 'AOP',
        },
        dtfModal: {
            headline: 'DTF Information',
            info: 'Damit deine Designs im DTF-Druck optimal umgesetzt werden, beachte bitte folgenden Hinweis:',
            points: [
                '<b>Keine halbtransparenten Designelemente</b>: Transparenzen oder Elemente mit verringerter Deckkraft lassen sich im DTF-Druck nicht sauber darstellen. Verwende stattdessen <b>deckende Farben</b> oder simuliere Transparenz durch <b>Halbtonmuster</b> (z.B. Punkte oder Rasterungen).',
            ],
            dontShowAgain: 'Warnung nicht noch einmal anzeigen',
            priceInformation:
                'Für die DTF-Drucktechnologie wird ein Aufpreis von 0,50€ (exkl. MwSt.) pro Artikel und zusätzlichem Druckbereich erhoben.',
            headlineWarning: 'DTF Warnung',
            transparencyWarning: 'Dieses Bild enthält transparente Pixel und kann unerwartet aussehen.',
            transparencyWarningUseDTG: 'Wir empfehlen, Ihr Design mit DTG zu drucken.',
            continueDtf: 'DTF beibehalten',
            continueDtg: 'DTG wählen (empfohlen)',
        },
        updateShopInfo: 'Dein Shop muss aktualisiert werden, um das Produkt hochzuladen. <br>Das kannst du <a href="/my-stores">hier</a> machen.',
        transparencyWarning: 'Dieses Bild enthält transparente Pixel und könnte unerwartet aussehen.',
        aiKeywordsLabel: 'Schlüsselwörter',
        aiKeywordsPlaceholder: 'z. B. Bio-Baumwolle, weich, Premium, nachhaltig',
        aiToneLabel: 'Ton',
        aiToneProfessional: 'Professionell',
        aiToneCasual: 'Lässig',
        aiToneFriendly: 'Freundlich',
        aiToneDaring: 'Gewagt',
        aiInstructionsLabel: 'Besondere Anweisungen',
        aiInstructionsPlaceholder: 'Optionaler Hinweis (Länge, hervorzuhebende Merkmale, etc.)',
        aiGenerateButton: 'Mit KI generieren',
        aiGenerateAgainButton: 'Generieren',
        aiKeepButton: 'Übernehmen',
        aiPreviewLabel: 'Vorschau',
        aiGenerateReplaces: 'Ersetzt die aktuelle Beschreibung',
        aiGenerateError: 'Beschreibung konnte nicht generiert werden. Bitte erneut versuchen.',
        salesRegion: 'Verkaufsregion',
        noRegionSelected: 'Keine Region ausgewählt',
        quickActions: {
            changeProduct: 'Produkt wechseln',
            addDesign: 'Design hinzufügen',
            changeProductTitle: 'Produkt wechseln',
            currentProduct: 'Aktuell',
        },
        createMultipleProducts: 'Mehrere Produkte erstellen',
    },
    multiDesigner: {
        title: 'Multi-Produkt Designer',
        subtitle: 'Entwerfen und erstellen Sie mehrere Produkte gleichzeitig',
        loading: 'Laden...',
        loadingMockups: 'Mockups werden generiert...',
        backToProducts: 'Zurück zu Produkten',
        backToDesign: 'Zurück zum Design',
        backToDesigner: 'Zurück zum Designer',
        addProduct: 'Weiteres Produkt hinzufügen',
        selectProduct: 'Produkt auswählen',
        searchProducts: 'Suchen',
        searchPlaceholder: 'Nach Name oder Typ suchen...',
        noProductsFound: 'Keine Produkte gefunden',
        maxReached: 'Maximum von {max} Produkten erreicht',
        products: 'Produkte',
        variants: 'Varianten',
        ready: 'Bereit',
        incomplete: 'Unvollständig',
        closeDesigner: 'Produkt entfernen',
        completeAllDesigners: 'Bitte vervollständigen Sie alle Produktdesigns, bevor Sie fortfahren',
        completeAllProducts: 'Bitte vervollständigen Sie alle Produktdetails vor dem Erstellen',
        confirmTitle: 'Produkte bestätigen',
        confirmSubtitle: 'Überprüfen und finalisieren Sie Ihre Produktdetails',
        shopSelectionTitle: 'Shops auswählen',
        shopSelectionSubtitle: 'Wählen Sie, zu welchen Shops alle Produkte hinzugefügt werden sollen',
        selectAtLeastOneShop: 'Bitte wählen Sie mindestens einen Shop aus',
        createAllProducts: 'Alle Produkte erstellen',
        successTitle: 'Produkte erstellt',
        successMessage: 'Ihre Produkte wurden erfolgreich erstellt!',
        productsCreated: 'Produkte erstellt',
        productsFailed: 'Produkte fehlgeschlagen',
        viewProducts: 'Meine Produkte anzeigen',
    },
    publishProduct: {
        title: 'Hinzufügen zu Shop',
    },
    aiAccess: {
        title: 'KI-Zugriff autorisieren',
        request: '{client} möchte in deinem MarketPrint-Konto handeln.',
        scopeCatalogue: 'Deine bedruckbaren Produkte durchsuchen',
        scopeUpload: 'Designs in dein Konto hochladen',
        scopeCreate: 'Produkte erstellen und in deinen verbundenen Shops veröffentlichen',
        ownAccountOnly: 'Der Zugriff gilt nur für dein eigenes Konto und kann jederzeit in den Kontoeinstellungen widerrufen werden.',
        allow: 'Erlauben',
        deny: 'Ablehnen',
        unknownClient: 'Ein KI-Assistent',
        missingInteraction: 'Dieser Autorisierungslink ist ungültig oder abgelaufen. Bitte starte erneut in deinem KI-Assistenten.',
        sessionExpired: 'Deine Sitzung ist abgelaufen. Bitte lade die Seite neu und melde dich erneut an.',
        failed: 'Die Autorisierung konnte nicht abgeschlossen werden. Bitte versuche es erneut.',
    },
    accountSettings: {
        title: 'Einstellungen',
        shopSettings: 'Shop Einstellungen',
        noShops: 'Noch keine Shops hinzugefügt.',
        subtitle: 'Verwalte deine Profileinstellungen.',
        contactInfo: 'Kontaktdaten',
        paymentInfo: 'Zahlungsinformationen',
        email: 'E-Mail',
        tel: 'Telefon',
        billingAddress: 'Rechnungsadresse',
        billingAddressTooltip: 'Dies ist die Adresse, die auf den Rechnungen erscheinen wird.',
        senderAddress: 'Absenderadresse',
        senderAddressTooltip:
            'Dies ist die Adresse, die als Absender auf den Versandetiketten erscheint. Es sind nur Adressen in Deutschland zulässig.',
        senderAddressEU: 'Absenderadresse (EU)',
        senderAddressUSA: 'Absenderadresse (USA)',
        senderAddressUSATooltip:
            'Dies ist die Adresse, die als Absender auf den Versandetiketten erscheint. Es sind nur Adressen in den USA zulässig.',
        paymentServiceProvider: 'Zahlungsdienstleister',
        paymentServiceProviderEU: 'Zahlungsdienstleister (EU)',
        paymentServiceProviderUS: 'Zahlungsdienstleister (US)',
        billingAgreement: 'Abrechnungsvereinbarung',
        deposited: 'Hinterlegt',
        changePaymentMethod: 'Zahlungsmethode ändern',
        tryAgain: 'Nochmal versuchen',
        addPayment: 'Hinzufügen',
        changePayment: 'Ändern',
        deletePayment: 'Löschen',
        deletePaymentTitle: 'Zahlungsmittel löschen',
        deletePaymentConfirm: 'Möchten Sie dieses Zahlungsmittel wirklich löschen?',
        deletePaymentDone: 'Zahlungsmittel gelöscht',
        retryPayment: 'Fehlgeschlagene Zahlung wiederholen',
        retryPaymentSuccess: 'Zahlungswiederholung ausgelöst',
        retryPaymentError: 'Zahlungswiederholung fehlgeschlagen',
        notifications: 'Benachrichtigungen',
        preferredLanguage: 'Sprache',
        preferredLanguageDescription:
            'Wenn du bei MarketPrint eingeloggt bist, ist dies die Sprache, die du siehst.<br/>Du kannst die Sprache jederzeit ändern.',
        productLanguage: 'Produkte im Shop Anlegen',
        productLanguageDescription: 'Hier änderst du die Sprache deines Produkts und die Maßeinheit der Größentabelle beim Import in deinen Shop.',
        preferredPrinterTypeTeeInBlue: 'Bevorzugte Drucktechnik für Bestellungen über TeeInBlue:',
        apiToken: 'API Token',
        apiTokenDescription:
            'Hier kannst du ein API Token für verschiedene Services generieren. Nach der Erstellung des Tokens, kannst du es nur ein mal sehen. Bitte beware es sicher auf. Du kannst jederzeit ein neues Token generiern, was das alte Token invalidiert.',
        generate: 'Erstellen',
        regenerate: 'Neu Erstellen',
        popup: 'Bitte erlaube das PopUp Fenster, um deine Zahlungs-Daten zu hinterlegen',
        notificationsCheckbox: {
            failedPayment: 'Benachrichtigung erhalten, wenn Zahlungen fehlschlagen',
            personalizedDesign: 'Benachrichtigung erhalten, wenn ein personalisiertes Design hochgeladen werden muss',
            tips: 'Möchtest du Tipps und Infos von MarketPrint per E-Mail erhalten?',
        },
        editBillingAddress: 'Rechnungsadresse bearbeiten',
        address: {
            title: 'Anschrift',
            firstName: 'Vorname',
            lastName: 'Nachname',
            address1: 'Addresszeile 1',
            address2: 'Addresszeile 2',
            company: 'Firma',
            phone: 'Telefonnummer',
            email: 'E-Mail',
            name: 'Name / Firma',
            nameAddition: 'Zusatz (2. Zeile)',
            address1Street: 'Straße',
            address1Number: 'Hausnummer',
            city: 'Stadt',
            zip: 'PLZ',
            countryCode: 'Ländercode',
            countryName: 'Land',
            province: 'Bundesstaat',
            validate: {
                zipWarning: {
                    title: 'Falsche PLZ!',
                    content: 'Die eingegebene Postleitzahl ist ungültig. Bitte überprüfe deine Angabe.',
                },
            },
            noChanges: 'Bitte nimm Änderungen vor bevor du speicherst',
            phoneOrEmailRequired: 'Telefonnummer oder E-Mail ist erforderlich',
            vatId: 'Umsatzsteuer-ID',
            chooseExisting: '--- Bestehende Adresse wählen ---',
        },
        language: 'Sprache:',
        units: 'Einheiten:',
        shoeSizes: 'Schuhgrößen:',
        editSenderAddressToasts: {
            success: 'Absenderadresse erfolgreich gespeichert',
        },
        editInvoiceAddressToasts: {
            success: {
                content: 'Rechnungsadresse erfolgreich gespeichert',
            },
            unavailable: {
                title: 'Warnung',
                content:
                    'Wir können deine Umsatzsteuer-ID aktuell leider nicht überprüfen, aber deine Adresse wurde gespeichert. Bitte versuche es später erneut.',
            },
            invalid: {
                content: 'Die eingegebene Umsatzsteuer-ID ist ungültig. Bitte überprüfe deine Angabe.',
            },
            format: {
                content: 'Die eingegebene Umsatzsteuer-ID hat ein falsches Format. Bitte überprüfe deine Angabe.',
            },
        },
        save: 'Speichern',
        editSenderAddress: 'Absenderadresse bearbeiten',
        editSenderAddressEU: 'Absenderadresse (EU) bearbeiten',
        editSenderAddressUSA: 'Absenderadresse (USA) bearbeiten',
        general: 'Anschrift ändern',
        selectPayment: 'Bitte wählen',
        paypal: 'PayPal',
        creditCard: 'Kreditkarte',
        notDeposited: 'Nicht hinterlegt',
        deposit: 'Einzahlung tätigen',
        paymentError: 'Zahlungsmethode nicht verfügbar',
        tib: 'TeeInBlue',
        connectTibProductInfo: 'Verbinde deine TiB Produkte mit Marketprint',
        saveIntegrationApiInfosInfo: 'Speichere deine TiB API Informationen, um Versand Updates in TeeInBlue zu erhalten',
        webhookUrl: 'Webhook URL',
        stockAvailabilityTitle: 'Lagerverfügbarkeit',
        stockAvailabilityCheckbox: 'Lagerverfügbarkeit automatisch aktualisieren',
        stockAvailabilityDescription:
            'Ist diese Option aktiviert, werden deine Produkte automatisch als ausverkauft gesetzt, sobald es von unseren Lieferanten gerade nicht lieferbar ist oder das Produkt vom Hersteller abgesetzt worden ist.  <br> <br>Wenn diese Option nicht aktiviert ist, werden Produkte immer als verfügbar angezeigt, auch wenn das Produkt von unseren Lieferanten nicht mehr produziert wird oder nicht vorrätig ist.',
        updateEmail: {
            title: 'E-Mail-Adresse aktualisieren',
            placeholder: 'Neue E-Mail-Adresse',
            confirm: 'E-Mail-Adresse bestätigen',
            email: 'E-Mail-Adresse',
            button: 'E-Mail-Adresse aktualisieren',
            success: {
                title: 'Erfolg',
                message: 'Bitte folge den Anweisungen, die an deine E-Mail gesendet wurden, um deine neue E-Mail-Adresse zu bestätigen.',
            },
            error: {
                title: 'Fehler beim Aktualisieren der E-Mail-Adresse',
                emailExists: 'Die angegebene E-Mail-Adresse ist bereits registriert.',
                rateLimit: 'Zu viele Versuche. Bitte warte einen Moment und versuche es dann erneut.',
                unknown: 'Ein unbekannter Fehler ist aufgetreten. Bitte versuche es später erneut.',
            },
        },
        addShop: {
            title: 'Shop hinzufügen',
            reconnectTitle: 'Shop muss neu verbunden werden',
            howToLogin: 'Wo finde ich meine URL?',
            add: 'Hinzufügen',
            connectShop: 'verbinden',
            connectShopInfo: {
                etsy: 'Etsy ist ein Online-Marktplatz, auf dem Kleinunternehmer handgefertigte Produkte aus Bereichen wie Schmuck, Kunst und Mode verkaufen können.',
            },
        },
        disconnectShop: {
            title: 'Shop trennen',
            description:
                'Dies wird den Shop als getrennt markieren. Alles wird wie zuvor funktionieren, aber es ist dann möglich, den Shop mit einem anderen Konto zu verbinden. Wenn der Shop mit einem anderen Konto verbunden wird, werden alle relevanten Produkte und Designs für diesen Shop im neuen Konto dupliziert.',
            disconnect: 'Shop trennen',
            reconnect: 'Shop wieder verbinden',
            statusConnected: 'Status: <b style="color: var(--color-secondary)">Verbunden</b>',
            statusDisconnected: 'Status: <b style="color: var(--color-primary)">Getrennt</b>',
        },
        mcpTokens: {
            title: 'KI-Assistent-Zugriff',
            description:
                'Erstelle ein Zugriffstoken, damit ein KI-Assistent in deinem Namen deinen Katalog durchsuchen, Designs hochladen und Produkte in deinen verbundenen Shops anlegen kann. Behandle ein Token wie ein Passwort - wer es besitzt, kann in deinem Konto handeln. Du kannst es jederzeit widerrufen.',
            label: 'Name',
            labelPlaceholder: 'z. B. mein KI-Assistent',
            created: 'Erstellt',
            lastUsed: 'Zuletzt verwendet',
            status: 'Status',
            never: 'Nie',
            statusActive: 'Aktiv',
            statusRevoked: 'Widerrufen',
            statusExpired: 'Abgelaufen',
            create: 'Token erstellen',
            expiryNever: 'Läuft nie ab',
            expiryDays: 'Läuft in {days} Tagen ab',
            noTokens: 'Noch keine Zugriffstoken vorhanden.',
            mintedTitle: 'Dein neues Zugriffstoken',
            mintedWarning:
                'Kopiere es jetzt - aus Sicherheitsgründen wird es nicht erneut angezeigt. Falls du es verlierst, erstelle einfach ein neues.',
            copy: 'Kopieren',
            copied: 'Kopiert',
            copyFailed: 'Kopieren in die Zwischenablage nicht möglich. Bitte markiere das Token und kopiere es manuell.',
            dismiss: 'Fertig',
            revoke: 'Widerrufen',
            revokeTitle: 'Zugriffstoken widerrufen',
            revokeConfirm:
                '"{label}" widerrufen? Alles, was dieses Token verwendet, verliert sofort den Zugriff. Dies kann nicht rückgängig gemacht werden.',
            revoked: 'Zugriffstoken widerrufen.',
            revokeFailed: 'Das Token konnte nicht widerrufen werden. Bitte versuche es erneut.',
            mintFailed: 'Das Token konnte nicht erstellt werden. Bitte versuche es erneut.',
        },
    },
    shopSelector: {
        noShops: 'Keine Shops verfügbar',
        noShopSelected: 'Kein Shop ausgewählt',
        allShopsSelected: 'Alle Shops ausgewählt',
        notConnected: '(nicht installiert)',
        notOnboarded: '(nicht onboarded)',
        disconnected: '(getrennt)',
        all: 'Alle Shops',
    },
    myProducts: {
        title: 'Meine Produkte',
        editProducts: {
            title: 'Produkt bearbeiten',
            productTitle: 'Produkttitel',
            shopDomain: 'Shop',
            productTitlePlaceholder: 'Produkttitel',
            supportedPrinterTypes: 'Drucktechnik:',
            productInfo: 'Produktinformationen',
            syncsToAllShops: 'wird mit allen Shops synchronisiert',
            productDescription: 'Beschreibung:',
            productDescriptionPlaceholder: 'Produktbeschreibung eingeben...',
            metadataSyncInfo: 'Änderungen werden mit allen Shops synchronisiert, in denen dieses Produkt veröffentlicht ist.',
            shopSettings: 'Shop-Einstellungen',
            perShop: 'pro Shop',
            syncingToShops: 'Synchronisiere mit',
            shops: 'Shops',
            editDesign: 'Design bearbeiten',
            editDesignDescription: 'Um Titel, Beschreibung, Varianten oder Design zu ändern, verwenden Sie den Designer.',
            editDesignHint: 'Druckdateien und Design-Platzierung ändern',
            variantPrices: 'Variantenpreise',
            variantSyncInfo: 'Preisänderungen werden mit allen Shops synchronisiert, in denen dieses Produkt veröffentlicht ist.',
            variantManagement: 'Variantenverwaltung',
            addVariants: 'Varianten hinzufügen',
            removeVariant: 'Variante entfernen',
            toBeRemoved: 'Wird entfernt',
            newVariant: 'Neu',
        },
        editAllProducts: 'Alle Produkte bearbeiten',
        editAllProductsWarning: 'Dies ändert die Drucktechnik für alle Produkte des gewählten Shops. Dies kann nicht rückgängig gemacht werden.',
        editAllProductsError: 'Beim Speichern der Änderungen ist ein Fehler aufgetreten',
        editAllProductsSuccess: 'Die Drucktechnik für alle Produkte des gewählten Shops wurde erfolgreich geändert',
        editProductsError: 'Beim Speichern der Änderungen ist ein Fehler aufgetreten',
        editProductsSuccess: 'Die Drucktechnik für das Produkt wurde erfolgreich geändert',
        multiExport: {
            button: 'Multi-Produkt kreieren',
            title: 'Multi-Produkt kreieren',
            steps: {
                products: 'Produkte auswählen',
                details: 'Titel & Preise',
            },
            selectStoreTitle: 'Shop auswählen',
            selectStoreSubtitle: 'Wähle den Shop, aus dem die Produkte kombiniert werden',
            step1Title: 'Produkte auswählen',
            step2Title: 'Titel, Beschreibung und Preise festlegen',
            noEligibleProducts: 'Keine passenden Produkte für diesen Shop gefunden',
            searchPlaceholder: 'Produkte suchen...',
            noSearchResults: 'Keine Produkte entsprechen deiner Suche',
            variants: 'Varianten',
            selectedProducts: 'Ausgewählte Produkte',
            detailsHeader: 'Produktdetails',
            pricesHeader: 'Variantenpreise',
            previewTitle: 'Vorschau',
            productLabel: 'Produkt {number} - {title}',
            skuWarning:
                'Bearbeite die SKUs dieser Varianten nach dem Export nicht in Shopify - andernfalls funktioniert die Auftragsabwicklung für diese Variante nicht mehr.',
            submit: 'Produkt erstellen',
            createNew: 'Neues Multi-Produkt erstellen',
            success: 'Produkt erfolgreich erstellt:',
            partialFailure: 'Das Produkt wurde erstellt, einige Varianten konnten jedoch nicht angelegt werden:',
            error: 'Das kombinierte Produkt konnte nicht erstellt werden. Bitte versuche es erneut.',
            productLoadFailed: 'Dieses Produkt konnte nicht geladen werden. Bitte versuche es erneut.',
        },
    },
    noResults: {
        text: 'Es sind noch keine Bestellungen vorhanden',
        products: 'In dieser Kategorie sind noch keine Produkte verfügbar',
    },
    noShops: {
        connected: 'Derzeit sind keine Shops verbunden. Um einen Shop zu verbinden, gehe zu den',
        settings: 'Einstellungen',
    },
    shared: {
        yes: 'Bestätigen',
    },
    invoices: {
        title: 'Rechnungen',
        startDate: 'Anfangsdatum',
        endDate: 'Enddatum',
        shop: 'Shop',
        download: 'PDF Download',
        downloadCSV: 'CSV Download',
        annotation:
            'Der Download der PDF-Dateien kann einige Zeit in Anspruch nehmen. Bitte beachten Sie, dass die maximale Anzahl an Rechnungen 5.000 beträgt. Die Download-Zeiten variieren. Im Schnitt braucht der Download von 1.000 Rechnungen etwa 5 Minuten.',
        noResults: 'Keine Rechnungen in diesem Zeitraum vorhanden.',
        countFound: 'Anzahl Rechnungen im gewählten Zeitraum: {count}',
        countWarning:
            'Warnung: Die Anzahl der Rechnungen im gewählten Zeitraum überschreitet das Limit von {limit} Rechnungen. Bitte passen Sie den Zeitraum an.',
        downloadDisabled:
            'Downloads sind deaktiviert, da die Anzahl der Rechnungen das Limit von {limit} Rechnungen überschreitet. Bitte passen Sie den Zeitraum an, um fortzufahren.',
    },
    login: {
        install1: `Melde dich<br>bei `,
        install2: ' an',
        shopUrl: 'Shopify Domain eingeben (SHOPNAME.myshopify.com):',
        redirect: 'Weiterleitung...',
        login: 'Anmelden',
        marketprint: 'MarketPrint',
        company: 'MarketPrint - ein MarketConsultive GmbH Unternehmen',
        companyAddress: 'Allgäuerstraße 20, 87719 Mindelheim, Deutschland',
        password: 'Passwort',
        registerInstead: 'Registrieren',
        error: {
            title: 'Login Fehler',
            rateLimit: 'Zu viele Login-Versuche. Bitte warte einen Moment und versuche es dann erneut.',
            emailNotConfirmed: 'Diese E-Mail-Adresse wurde noch nicht bestätigt.',
            invalidCredentials: 'Ungültige Anmeldedaten.',
            firstTimeApiCallFailed:
                'Dein Konto wurde erstellt, aber es gab einen internen Fehler. Bitte versuche dich anzumelden oder dich erneut zu registrieren.',
            unknown: 'Ein unbekannter Fehler ist aufgetreten. Bitte versuche es später erneut.',
        },
    },
    emailResend: {
        title: 'Bestätigungs-E-Mail erneut senden',
        success: {
            title: 'Erfolg',
            message: 'Die Bestätigungs-E-Mail wurde erneut gesendet.',
        },
        error: {
            title: 'Fehler beim erneuten Senden',
            rateLimit: 'Zu viele Versuche. Bitte warten Sie einen Moment und versuchen Sie es erneut.',
            unknown: 'Ein unbekannter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.',
        },
    },
    forgotPassword: {
        forgotPassword: 'Passwort vergessen?',
        enterEmail: 'Bitte geben Sie Ihre E-Mail-Adresse ein, um einen Passwort-Zurücksetzen-Link zu erhalten.',
        resetPassword: 'Passwort zurücksetzen',
        success: {
            title: 'Erfolgreich',
            message: 'Ein E-Mail wurde an Ihre E-Mail-Adresse mit einem Passwort-Zurücksetzen-Link gesendet.',
        },
        error: {
            title: 'Fehler beim Zurücksetzen des Passworts',
            unknown: 'Ein unbekannter Fehler ist aufgetreten. Bitte versuche es später erneut.',
        },
    },
    updatePassword: {
        success: {
            title: 'Erfolgreich',
            message: 'Ihr Passwort wurde erfolgreich aktualisiert.',
        },
        error: {
            title: 'Fehler beim Aktualisieren des Passworts',
            samePassword: 'Das Passwort sollte sich vom alten Passwort unterscheiden.',
        },
        confirm: 'Passwort Bestätigung',
        button: 'Passwort aktualisieren',
        placeholder: 'Neues Passwort',
        title: 'Passwort aktualisieren',
        nonceMessage: 'Ein Code wurde an Deine E-Mail-Adresse gesendet. Bitte gebe den Code unten ein, um fortzufahren.',
        noncePlaceholder: 'Einmaliger Code',
        nonceInvalid: 'Der angegebene Code ist ungültig.',
    },
    register: {
        register: 'Registrieren',
        loginInstead: 'Einloggen',
        error: {
            title: 'Registrierungsfehler',
            rateLimit: 'Zu viele Registrierungsversuche. Bitte warte einen Moment und versuche es dann erneut.',
            emailExists: 'Diese E-Mail-Adresse ist bereits registriert.',
            weakPassword:
                'Das eingegebene Passwort ist zu schwach. Das Passwort muss mindestens 8 Zeichen lang sein und einen Groß-/Kleinbuchstaben, eine Zahl und ein Sonderzeichen enthalten.',
            unknown: 'Ein unbekannter Fehler ist aufgetreten. Bitte versuche es später erneut.',
        },
        success: {
            title: 'Registrierung erfolgreich',
            message: 'Du hast dich erfolgreich registriert. Bitte überprüfe deine E-Mails, um deinen Account zu bestätigen.',
        },
    },
    onboarding: {
        title: 'Willkommen bei MarketPrint!',
        welcomeText: `Vielen Dank, dass Du unsere Print on Demand Dienstleistung nutzen willst!<br><br>
            Wir sind ein modernes & leidenschaftliches Unternehmen, welches eine All-in-One Print on Demand Leistung anbietet und alles dafür setzt, Shopify Online Händlern die beste und einfachste User Experience im Online Handel zu bieten.<br>
            Wir arbeiten kontinuierlich an unserer App und unserem Service, um das Geschäftsmodell Print on Demand für jeden zugänglich zu machen und Dir die Möglichkeit zu bieten, auf ein ständig wachsendes Produktportfolio und einen automatisierten Bestell-Prozess zurückzugreifen.<br><br>
            Wir haben immer ein offenes Ohr für Verbesserungsvorschläge bezüglich unserer Shopify App. Ruft uns hierfür gerne an oder schreibt unserem Support.<br><br>
            Viel Spaß mit der MarketPrint App und auf viele gute Verkäufe,<br>
            Team MarketPrint`,
        privacy:
            "Ich habe die <a href='https://marketprint.de/agb/' target='_blank'>AGB</a> und <a href='https://marketprint.de/datenschutzerklarung-marketprint-app/' target='_blank'>Datenschutzerklärung</a> gelesen und erkläre mich mit diesen einverstanden",
        emailNotifications: 'Ich möchte von MarketPrint über neue Produkte und Neuigkeiten per E-Mail informiert werden',
        formTitle: 'Ganz wichtig für den perfekten Start:',
        formText: `Damit Deine eingehenden Bestellungen automatisiert abgewickelt werden können, musst Du Deine Zahlungsmethode hinterlegen. Wir bieten Dir PayPal oder Kreditkarte als Option an und empfehlen Dir für einen reibungslosen Start Deine Zahlungsmethode & Rechnungsadresse jetzt zu hinterlegen.<br><br>
            Bitte fülle das Formular aus und wähle die für Dich geeignete Zahlungsmethode:`,
        billingAddress: 'Rechnungsadresse hinzufügen:',
        name: 'Name:',
        namePlaceholder: 'Name angeben',
        firstName: 'Vorname:',
        firstNamePlaceholder: 'Vorname angeben',
        company: 'Name/ Firma:',
        companyPlaceholder: 'Name / Firma angeben',
        addressStreet: 'Straße:',
        addressStreetPlaceholder: 'Straße hinzufügen',
        addressNumber: 'Hausnummer:',
        addressNumberPlaceholder: 'Hausnummer hinzufügen',
        postcode: 'PLZ:',
        postcodePlaceholder: 'PLZ hinzufügen',
        country: 'Land:',
        countryPlaceholder: 'Land auswählen',
        paymentMethod: 'Zahlungsdienstleister auswählen:',
        thankYouTitle: 'Du hast es geschafft! 🎉',
        thankYouText: `Du hast alles erledigt und bist bereit für die Produktkreierung und den Verkauf deiner eigenen Marke.<br>
            Lass uns gemeinsam Dein allererstes Produkt erstellen. Du wirst sehen, wie leicht und schnell das geht.<br><br>
            Probiere es gleich aus, klicke einfach auf den Button und lass uns direkt mit einem unserer Bestseller Dein erstes Produkt kreieren.`,
        thankYouNext: 'Jetzt loslegen!',
        thankYouBack: 'Überspringen',
        city: 'Stadt:',
        cityPlaceholder: 'Stadt hinzufügen',
        error: {
            title: 'Kontoinformationen konnten nicht gespeichert werden',
            backendContent: 'Fehler beim Speichern der Daten',
        },
        regionLabel: 'Wo verkaufst du hauptsächlich?',
        sourceLabel: 'Wie hast du von uns erfahren?',
        sourceSelect: 'Bitte auswählen...',
        sourceOtherLabel: 'Sonstige (bitte angeben)',
        sourceOtherPlaceholder: 'Bitte angeben...',
        sourceFriends: 'Freunde & Bekannte',
        sourceOther: 'Sonstige',
        sourceAppStore: 'App Store',
        sourceGoogle: 'Google Suche',
        sourceSocial: 'Social Media',
        tiktokResponsiblePerson: {
            title: 'Verantwortliche Person (EU-Konformität)',
            hint: 'TikTok schreibt für EU-Shops vor, dass eine verantwortliche Person für die Produktkonformität registriert wird. Diese Person haftet gegenüber Behörden für die Einhaltung der EU-Vorschriften. Bitte fülle alle Felder aus — diese Angaben werden direkt an TikTok übermittelt und sind Pflicht, um Produkte exportieren zu können.',
            name: 'Name / Firmenname:',
            namePlaceholder: 'Max Mustermann oder Musterfirma GmbH',
            email: 'E-Mail:',
            emailPlaceholder: 'verantwortlich@beispiel.de',
            phoneCountryCode: 'Ländervorwahl:',
            phoneCountryCodePlaceholder: '+49',
            phoneLocalNumber: 'Telefonnummer:',
            phoneLocalNumberPlaceholder: '15123456789',
            street: 'Straße & Hausnummer:',
            streetPlaceholder: 'Musterstraße 1',
            postalCode: 'PLZ:',
            postalCodePlaceholder: '12345',
            country: 'Land:',
            error: 'Die Daten konnten nicht an TikTok übermittelt werden. Bitte überprüfe deine Angaben.',
        },
    },
    success: {
        title: 'Erfolgreich',
    },
    error: {
        title: 'Fehler',
        content: 'Ein Fehler ist aufgetreten',
    },
    header: {
        notifications: 'Benachrichtigungen',
    },
    countries: {
        Deutschland: 'Deutschland',
        Österreich: 'Österreich',
        Schweiz: 'Schweiz',
        Andorra: 'Andorra',
        Belgien: 'Belgien',
        Bulgarien: 'Bulgarien',
        Dänemark: 'Dänemark',
        Estland: 'Estland',
        Finnland: 'Finnland',
        Frankreich: 'Frankreich',
        Griechenland: 'Griechenland',
        Irland: 'Irland',
        Italien: 'Italien',
        Kroatien: 'Kroatien',
        Lettland: 'Lettland',
        Luxemburg: 'Luxemburg',
        Monaco: 'Monaco',
        Niederlande: 'Niederlande',
        Norwegen: 'Norwegen',
        Polen: 'Polen',
        Portugal: 'Portugal',
        'San Marino': 'San Marino',
        Schweden: 'Schweden',
        Slowakei: 'Slowakei',
        Slowenien: 'Slowenien',
        Spanien: 'Spanien',
        'Tschechische Republik': 'Tschechische Republik',
        Ungarn: 'Ungarn',
        Vatikanstadt: 'Vatikanstadt',
        'Vereinigtes Königreich': 'Vereinigtes Königreich',
        Zypern: 'Zypern',
        Kosovo: 'Kosovo',
        Litauen: 'Litauen',
        Malta: 'Malta',
        Rumänien: 'Rumänien',
        Albanien: 'Albanien',
        'Bosnien und Herzegowina': 'Bosnien und Herzegowina',
        Liechtenstein: 'Liechtenstein',
        Mazedonien: 'Mazedonien',
        Moldau: 'Moldau',
        Montenegro: 'Montenegro',
        Serbien: 'Serbien',
        'Vereinigte Staaten': 'Vereinigte Staaten',
        'Zone 1': 'Zone 1',
        'Zone 2': 'Zone 2',
        'Zone 3': 'Zone 3',
        'Zone 4': 'Zone 4',
    },
    codeToCountry: {
        AE: 'Vereinigte Arabische Emirate',
        AT: 'Österreich',
        BE: 'Belgien',
        BG: 'Bulgarien',
        CY: 'Zypern',
        CZ: 'Tschechien',
        DE: 'Deutschland',
        DK: 'Dänemark',
        EE: 'Estland',
        EL: 'Griechenland',
        ES: 'Spanien',
        FI: 'Finnland',
        FR: 'Frankreich',
        GR: 'Griechenland',
        HR: 'Kroatien',
        HU: 'Ungarn',
        IE: 'Irland',
        IT: 'Italien',
        LT: 'Litauen',
        LU: 'Luxemburg',
        LV: 'Lettland',
        MT: 'Malta',
        NL: 'Niederlande',
        PL: 'Polen',
        PT: 'Portugal',
        RO: 'Rumänien',
        SE: 'Schweden',
        SI: 'Slowenien',
        SK: 'Slowakei',
        GB: 'Vereinigtes Königreich',
        CH: 'Schweiz',
        NO: 'Norwegen',
        US: 'Vereinigte Staaten',
    },
    shippingTable: {
        canvas: 'Canvas',
        poster: 'Poster',
        basePrice: 'Grundpreis',
        perAdditionalProduct: 'Je Weiteres Product',
    },
    time: {
        today: 'Heute',
        nDaysAgo: 'Vor {n} Tagen',
        '1DayAgo': 'Vor 1 Tag',
    },
    unitSystems: {
        metric: 'cm/ml (Metrisch)',
        imperial: 'inch/oz (Imperial)',
        both: 'cm + inch (Beides)',
    },
    shoeSizeSystem: {
        eu: 'EU',
        us: 'US',
        uk: 'UK',
    },
    affiliateProgram: {
        title: 'Affiliate Programm',
        activeShopsLastYear: 'Shops jünger als 1 Jahr',
        allShops: 'Alle Shops',
        payouts: 'Auszahlungen',
        payoutDate: 'Auszahlungsdatum',
        payoutAmount: 'Auszahlungsbetrag',
        payoutStatus: 'Auszahlungsstatus',
        btnDownloadPayout: 'Auszahlung herunterladen',
        payoutInfo: 'Auszahlungsinformationen',
        paymentServiceProvider: 'Zahlungsdienstleister',
        billingAgreement: 'Abrechnungsvereinbarung',
        deposited: 'Hinterlegt',
        addNewPaymentMethod: 'Neue Zahlungsmethode hinzufügen',
        changePaymentMethod: 'Zahlungsmethode aktualisieren',
        tryAgain: 'Nochmal versuchen',
        popup: 'Bitte erlaube das PopUp Fenster, um deine Zahlungsdaten zu hinterlegen',
        selectPayment: 'Bitte wählen Sie',
        paypal: 'PayPal',
        creditCard: 'Kreditkarte',
        billingAddress: 'Rechnungsadresse',
        paymentStatus: {
            open: 'Offen',
            invoice_upload_pending: 'Rechnung hochladen',
            invoice_being_verified: 'Rechnung wird überprüft',
            payment_pending: 'Zahlung ausstehend',
            paid: 'Bezahlt',
            failed: 'Fehlgeschlagen',
        },
    },
    marketPrintSolutions: {
        title: 'MarketPrint Solutions',
        returnmanagement: 'Retourenmanagement',
        itemOverview: 'Artikelübersicht',
        subscription: 'Abonnement',
        bundling: 'Bundling (coming soon)',
    },
    betaFeatures: {
        workInProgress: 'Funktion in Bearbeitung',
        comingSoon: 'Demnächst verfügbar',
    },
    wallet: {
        title: 'Wallet',
        balance: 'Guthaben',
        activate: 'Wallet aktivieren',
        activateHint:
            'Aktivieren Sie das Wallet für diese Region, um es per Banküberweisung aufzuladen und Bestellungen automatisch daraus zu bezahlen.',
        activationRequirementHint: 'Noch nicht verfügbar: {orderCount} von {requiredOrderCount} benötigten Bestellungen in den letzten 90 Tagen.',
        payout: 'Auszahlung anfordern',
        payoutRequested: 'Auszahlung erfolgreich angefordert',
        payoutFailed: 'Auszahlungsanfrage fehlgeschlagen. Bitte versuchen Sie es erneut.',
        payoutConfirm:
            'Das komplette Wallet-Guthaben wird auf Ihr Bankkonto ausgezahlt. Sie erhalten anschließend eine E-Mail mit den genauen Anweisungen. Möchten Sie fortfahren?',
        tableHeaders: {
            date: 'Datum',
            description: 'Beschreibung',
            invoiceNumber: 'Rechnung',
            amount: 'Betrag',
            status: 'Status',
        },
        fundingTitle: 'Einzahlungsinformationen',
        fundingAccountHolder: 'Kontoinhaber',
        fundingAccountNumber: 'Kontonummer',
        fundingSortCode: 'Bankleitzahl',
        fundingRoutingNumber: 'Routing-Nummer',
        fundingSwiftCode: 'SWIFT/BIC',
        fundingBankName: 'Bank',
        fundingNetworkAba: 'Inland (ACH / Wire)',
        fundingNetworkSwift: 'International (SWIFT)',
        fundingHint:
            'Diese Bankverbindung gehört unserem Zahlungsdienstleister (Stripe) und dient ausschließlich dem Aufladen Ihres Wallet-Guthabens – nicht MarketPrint direkt. Bitte überweisen Sie exakt auf den angezeigten Kontoinhaber und die IBAN; der Betrag wird Ihrem Wallet automatisch gutgeschrieben.',
        transactions: 'Transaktionen',
        viewTransactions: 'Transaktionen anzeigen',
        methodOrderTitle: 'Reihenfolge der Zahlungsmethoden',
        methodOrderSaved: 'Reihenfolge der Zahlungsmethoden gespeichert',
        noMethodsActive: 'Keine Zahlungsmethoden aktiv',
        notConfigured: 'nicht eingerichtet',
        methodActivate: 'Aktivieren',
        methodDeactivate: 'Deaktivieren',
        lastMethodHint: 'Mindestens eine Zahlungsmethode muss aktiv bleiben.',
        moveUp: 'Nach oben',
        moveDown: 'Nach unten',
        status: {
            completed: 'Abgeschlossen',
            failed: 'Fehlgeschlagen',
            pending: 'Ausstehend',
        },
        methods: {
            wallet: 'Wallet',
            credit_card: 'Kreditkarte',
            paypal: 'PayPal',
        },
        notifications: {
            title: 'Wallet',
            lowBalance: 'Bei niedrigem Guthaben per E-Mail benachrichtigen',
            threshold: 'Schwellenwert',
            thresholdHint: 'Fällt dein Guthaben unter diesen Betrag, erhältst du eine Benachrichtigung per E-Mail. Mindestwert: 30.',
            funding: 'Bei Einzahlung per E-Mail benachrichtigen',
            notActiveWarning: 'Das Wallet ist aktuell nicht die aktive Zahlungsmethode für diese Region.',
        },
        descriptionKey: {
            order_debit: 'Abbuchung für Bestellung {orderReference}',
            order_refund: 'Rückerstattung für Bestellung {orderReference}',
            stripe_bank_transfer: 'SEPA-Einzahlung von {senderName}',
            payout_expired: 'Auszahlung abgelaufen — Guthaben zurückgebucht (Refund {refundId})',
            payout_pending: 'Auszahlung an Kundenkonto angefordert',
            payout_completed: 'Auszahlung an Kundenkonto abgeschlossen',
            payout_failed: 'Auszahlung an Kundenkonto fehlgeschlagen',
            payout_reversed: 'Auszahlung fehlgeschlagen, Betrag zurückgebucht ({errorMessage})',
            fallback: '{description}',
        },
    },
};

export default app;
